import React from 'react'

export const EventDates = ({ displayEventSettings, event, lang }) => {
    return <p className="dates">
        {displayEventSettings["ShowEventStartDateTime"] ? new Date(event.startDateTime).toLocaleDateString(lang === "swe"? "sv-SE" : "en-GB") : null}
        {displayEventSettings["ShowEventStartTime"] ? (displayEventSettings["ShowEventStartDateTime"] ? " " : "") + new Date(event.startDateTime).toLocaleTimeString(lang === "swe"? "sv-SE" : "en-GB", { timeStyle: 'short' }) : null}
        {(displayEventSettings["ShowEventStartDateTime"] || displayEventSettings["ShowEventStartTime"]) &&
            (displayEventSettings["ShowEventEndDateTime"] || displayEventSettings["ShowEventEndTime"]) ?
            ' - ' : null}
        {displayEventSettings["ShowEventEndDateTime"] ? new Date(event.endDateTime).toLocaleDateString(lang === "swe"? "sv-SE" : "en-GB") : null}
        {displayEventSettings["ShowEventEndTime"] ? (displayEventSettings["ShowEventEndDateTime"] ? " " : "") + new Date(event.endDateTime).toLocaleTimeString(lang === "swe"? "sv-SE" : "en-GB", { timeStyle: 'short' }) : null}
    </p>
}

